import iconSelected from '@assets/images/static/icon-valid-bleu.png';
import { styled } from 'styled-components';
import { SSpanTitle } from '~/pages/components/styles/styles';

type IProps = {
  name: string;
  pnjImageSrc?: string;
  pnjName?: string;
  onClick?: () => void;
  selected?: boolean;
};

function ThematiqueSelected({ name, pnjImageSrc, onClick, selected }: IProps) {
  return (
    <Container selected={selected} onClick={onClick}>
      <SImgCharacter src={pnjImageSrc} alt="" />
      <SDivBlur>
        <SSpanTitle>{name}</SSpanTitle>
      </SDivBlur>
      {selected && <SImgSelected src={iconSelected} alt="" />}
    </Container>
  );
}

export default ThematiqueSelected;

const Container = styled.button<{ selected?: boolean }>`
  align-items: flex-end;
  border-radius: 19px;
  box-shadow:
    inset 0 3.6px 3.6px 0 rgba(255, 255, 255, 0.35),
    inset 0 -3.6px 3.6px 0 rgba(0, 0, 0, 0.4);
  border-left: ${({ selected }) => (selected ? 'solid 1px #009fc3' : 'none')};
  border-top: ${({ selected }) => (selected ? 'solid 1px #009fc3' : 'none')};
  border-right: ${({ selected }) => (selected ? 'solid 1px #009fc3' : 'none')};
  border-bottom: ${({ selected }) => (selected ? 'solid 4px #009fc3' : 'none')};

  background-color: #ccecf3;
  cursor: pointer;

  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  margin: 10px;
  position: relative;
  width: 45%;
  transition: transform 0.3s ease;
  pointer-events: none;

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;
const SImgCharacter = styled.img`
  left: 0;
  height: 100%;
  top: 0;
  object-fit: contain;
  position: absolute;
  width: 100%;
`;

const SImgSelected = styled.img`
  right: 0;
  height: 30px;
  position: absolute;
  object-fit: contain;
  top: 0;
  width: 30px;
`;

const SDivBlur = styled.div`
  align-items: flex-end;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) -0%,
    #fff 156%
  );
  display: flex;
  justify-content: center;
  left: 0;
  height: 33%;
  padding: 5px;
  position: absolute;

  bottom: 0;
  width: 100%;
`;
